module.exports = __webpack_public_path__ + "static/img/naozhong.7160efc9.svg";